<template>
  <el-dialog
    :title="data.title"
    :visible="true"
    @close="eventClose"
    width="50%"
    :fullscreen="false"
    :close-on-click-modal="false"
  >
    <el-form
      :loading="loading"
      status-icon
      :model="data.ruleForm"
      :rules="data.rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item
        v-for="item in data.itemData"
        v-if="!item.hidden || /添加|新建/.test(data.title)"
        :key="item.code"
        :label="item.name"
        :prop="item.code == 'password' && data.isEditUser ? '' : item.code"
      >
        <el-input
          v-if="!item.isSelect"
          v-model.trim="data.ruleForm[item.code]"
          :disabled="!/添加|新建/.test(data.title) && item.code == 'username'"
        ></el-input>
        <el-select
          clearable
          v-else
          v-model="data.ruleForm[item.code]"
          placeholder="请选择状态"
        >
          <el-option
            v-for="item2 in item.data"
            :key="item2.value"
            :label="item2.label"
            :value="item2.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :loading="btLoading"
        >
          {{ btLoading ? '提交中' : '提交' }}
        </el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { objectFormat } from '@/tools/objectFormat.js';
import { btLoading } from '@/Mixin/btLoading';

export default {
  mixins: [btLoading],
  props: {
    showUserAddEdit: {
      // 是否显示
      type: Boolean,
      default: false
    },
    ruleForm: {
      // 对应数据
      default() {
        return {};
      }
    },
    /*
            表单，验证，接口，title
            */
    data: {
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      loading: true, // 表单 loading
      formLabelWidth: '120px'
    };
  },
  methods: {
    eventClose() {
      // 关闭窗口
      this.$emit('update:showUserAddEdit', false); // 逆向修改
      this.$message({
        type: 'info',
        message: '取消输入'
      });
    },
    //提交
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 改变按钮状态
          this.SET_BTLOADING(true);
          /*
                          Function  objectFormat 过滤提交参数
                          {sendAjax} 提交地址
                        */
          let obj = objectFormat(this.data.ruleForm);
          Object.assign(obj, { departmentId: 1 });
          this.data.sendAjax[
            /修改|编辑/.test(this.data.title) ? 'edit' : 'add'
          ](obj).then(res => {
            this.$notify({
              title: '成功',
              message: `${this.data.title}成功`,
              type: 'success'
            });
            this.$emit('update:showUserAddEdit', false); // 逆向修改
            this.$emit('save-success', true); // 通知父组件更新数据
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  created() {
    if (this.data.isEditUser) {
      this.data.ruleForm.password = '';
    }
    if (this.data.type == 'edit' && this.data.sendAjax.getInfo) {
      this.data.sendAjax.getInfo({ id: this.data.ruleForm.id }).then(res => {
        this.data.ruleForm = res.data.data;
      });
    }
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }
};
</script>
